import { render, staticRenderFns } from "./UserAvatarDropdown.vue?vue&type=template&id=76442238&scoped=true"
import script from "./UserAvatarDropdown.vue?vue&type=script&lang=js"
export * from "./UserAvatarDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarDropdown.vue?vue&type=style&index=0&id=76442238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76442238",
  null
  
)

export default component.exports